import { render, staticRenderFns } from "./SportsMajor.vue?vue&type=template&id=60962ebd&scoped=true"
import script from "./SportsMajor.vue?vue&type=script&lang=js"
export * from "./SportsMajor.vue?vue&type=script&lang=js"
import style0 from "./SportsMajor.vue?vue&type=style&index=0&id=60962ebd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60962ebd",
  null
  
)

export default component.exports